import { render } from "./ModuleHomeExperience.vue?vue&type=template&id=51c710d8"
import script from "./ModuleHomeExperience.vue?vue&type=script&lang=js"
export * from "./ModuleHomeExperience.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__